import { catchError, map, of, tap } from 'rxjs';

import { HttpStatusCode } from '@angular/common/http';
import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { CoreService } from '../services/core.service';
import { HelperService } from '../services/helper.service';

export const authGuard: CanActivateFn = (route, state) => {
  const TOKEN_KEY = 'access_token';
  const paramToken = route.queryParamMap.get(TOKEN_KEY);
  if (paramToken) {
    localStorage.setItem(TOKEN_KEY, paramToken);
  }
  const accessToken = paramToken ? paramToken : localStorage.getItem(TOKEN_KEY);
  const router = inject(Router);
  const coreService = inject(CoreService);
  const helperService = inject(HelperService);
  function backToLogin() {
    router.navigate(['/login'], {
      queryParams: state.url !== '/' && state.url !== '/dashboard' ? { returnUrl: state.url } : null
    });
  }

  if (accessToken) {
    return coreService.postRequest('role/auth/check', { portal: 'admin' }).pipe(
        map((response) => {
            const isAuthorized = response.data;

            if(!isAuthorized) {
                backToLogin();
                return isAuthorized
            }

            return isAuthorized;
        }), 
        catchError(error => {
          return of(false).pipe(
            tap(() => {
              helperService.removeTokenAndLogout();
              backToLogin();
            })
          );
        })
    );
  }

  return of(false).pipe(
    tap(() => {
      backToLogin();
    })
  );
};